var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('hero-section'),_c('section-servicios'),_c('section-video-empresa'),_c('section-proyectos'),_c('section-quotes'),_c('section-alianzas')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }